import { useEffect, useRef } from 'react';
import { trackScrollDepth, trackTimeOnPage } from '../utils/gtm';

const GTMTracker = ({ pageName }) => {
  const startTime = useRef(Date.now());
  const scrollDepths = useRef(new Set());

  useEffect(() => {
    // Track time on page
    const handleBeforeUnload = () => {
      const timeSpent = Math.round((Date.now() - startTime.current) / 1000);
      trackTimeOnPage(timeSpent, pageName);
    };

    // Track scroll depth
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = Math.round((scrollTop / docHeight) * 100);
      
      // Track at 25%, 50%, 75%, and 100% scroll depth
      const milestones = [25, 50, 75, 100];
      milestones.forEach(milestone => {
        if (scrollPercent >= milestone && !scrollDepths.current.has(milestone)) {
          scrollDepths.current.add(milestone);
          trackScrollDepth(milestone);
        }
      });
    };

    // Add event listeners
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [pageName]);

  return null; // This component doesn't render anything
};

export default GTMTracker;
